module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_ENSEIGNES_EN_CUISINE.3c95e899.png";